import React, { Component } from 'react'

import RegistrationForm from 'components/RegistrationForm'

import { API_HOST } from 'config'

const savePro = (data) => {

    return fetch(`${API_HOST}/register/pros`,{
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then(res => {
        if (!res.ok) {
            throw new Error(res)
        }
        return res
    })
    .then(res => res.json())
}


class Home extends Component {

    state = {
        error: false,
        saved: false,
        loading: false
    }

    setStateAsync(state) {
        return new Promise((resolve) => {
            this.setState(state, resolve)
        })
    }
    
    savePro = async (payload) => {
        
        try{
            await this.setStateAsync({ 
                error: false,
                saved: false,
                loading: true
             })
        
            const pro = await savePro(payload)
            
            await this.setStateAsync({ 
                loading: false, 
                saved: true, 
                error: false,
                pro: pro
            })

        }
        catch(err){
            this.setState({
                error: true,
                saved: false,
                loading: false,
                pro: null
            })
        }
        
    }

    render(){

        return (
            <article className="page article">
                <section className="content">
                    <p>Coming soon</p>
                {/*
                <RegistrationForm 
                    onSubmit={this.savePro}
                    loading={this.state.loading}
                    saved={this.state.saved}
                />
                */}
                </section>
            </article>
        )
    }
}

export default Home



// WEBPACK FOOTER //
// ./src/pages/Home.js